//@flow
import React, { Component } from 'react';
import { type Currency } from '../../../utilities/types';
import { SummaryFooterP, DateSpan } from './CommissionDueShowStyles';
import { formatDate } from '../../../utilities/misc';
import { formatCurrency } from '../../../utilities/numberFormatting';

type Props = {
  exceedsMinimumPayout: boolean,
  payoutExpectedAt: string,
  endMonthMinimum: number,
  partnerCurrency: Currency,
  currencyType: string
};
export default class SummaryFooter extends Component<Props> {
  render() {
    if (this.props.currencyType === 'fiat') {
      if (this.props.exceedsMinimumPayout) {
        return (
          <SummaryFooterP>
            We will create the payout for these commissions on{' '}
            <DateSpan>
              {String(formatDate(this.props.payoutExpectedAt))}.
            </DateSpan>
          </SummaryFooterP>
        );
      } else {
        return (
          <SummaryFooterP>
            You haven’t reached the minimum payout amount of{' '}
            {formatCurrency(
              this.props.endMonthMinimum,
              this.props.partnerCurrency
            )}
            . When you reach{' '}
            {formatCurrency(
              this.props.endMonthMinimum,
              this.props.partnerCurrency
            )}
            , we will create the payout.
          </SummaryFooterP>
        );
      }
    } else {
      return <SummaryFooterP> {''}</SummaryFooterP>;
    }
  }
}
